<template>
    <div class="lesson">
        <div class="lesson_block">
            <div class="lesson_module_header">
                <div class="text">
                    Удаление урока
                </div>
                <div class="close" @click="$emit('close')">
                    <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.3751 4.1665L9.99951 8.5415L5.62489 4.1665L4.16669 5.62484L8.5413 9.99984L4.16669 14.3748L5.62489 15.8332L9.99951 11.4582L14.3751 15.8332L15.8334 14.3748L11.4587 9.99984L15.8334 5.62484L14.3751 4.1665Z" fill="#ABABB2"/>
                    </svg>
                </div>
            </div>
            <div class="lesson_module_main">
                <div class="text">
                    Вы уверены, что хотите удалить этот урок?
                </div>
                <div class="remove_button" @click="$emit('removeLesson')">
                    <button class="button">Удалить</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
@import "../../../styles_fonts.scss";

    $font_Geometria: Geometria, 'Geometria';

    $color_background: #F6F6FB;
    $color_Gray_1: #C5C5C9;
    $color_Gray_2: #ABABB2;
    $color_Gray_3: #EBEBEB;
    $color_black: #333333;
    $color_purple: #8C71FE;
    $color_red: #FF6597;
.lesson{
    .lesson_block{
       position: absolute;
        width:692px;
        height: 222px;
        background: #FFFFFF;
        
        box-sizing: border-box;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 12px;

        .lesson_module_header{
            background: #8C71FE;
            border-radius: 12px 12px 0px 0px;
            padding: 24px 40px 22px 40px;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;

            .text{
                
                font-family: $font_Geometria;
                font-style: normal;
                font-weight: bold;
                font-size: 22px;
                line-height: 120%;
                color: #FFFFFF;
            }
            .close{
                cursor: pointer;
            }

        }
        .lesson_module_main{
            margin:21px 40px 0 40px ;
            .text{
                font-family: $font_Geometria;
                font-style: normal;
                font-weight: normal;
                font-size: 17px;
                line-height: 21px;
                color: #333333;

            }
            .remove_button{
                margin-top:18px;
                float:right;
                .button{
                    font-family: $font_Geometria;
                    font-style: normal;
                    font-weight: bold;
                    font-size: 16px;
                    line-height: 20px;
                    display: flex;
                    align-items: center;
                    text-align: center;
                    color: #FFFFFF;
                    padding:16px 57px 14px 58px;
                    background: #8C71FE;
                    border-radius: 12px;
                    border:0;
                    outline: 0;
                    cursor: pointer;

                }
            }
        }
    }
}
</style>